import { useEffect, useState } from 'react';
import { useAppStore } from '@stores';

const images = [
  'assets/sprites-0.webp',
  'assets/sprites-1.webp',

  'assets/backgrounds/square.avif',
  'assets/backgrounds/water.avif',
  'assets/backgrounds/cave.avif',

  'assets/items/nanoForgeFragment.avif',
  'assets/items/magneticResonator.avif',
  'assets/items/precisionGearCore.avif',
  'assets/items/genesisSeedPrime.avif',
  'assets/items/primeMatrixCore.avif',
  'assets/items/stellarFragment.avif',
  'assets/items/symbioticSpore.avif',
  'assets/items/fusionFragment.avif',
  'assets/items/eternityShard.avif',
  'assets/items/quantumTangle.avif',
  'assets/items/gravityPearl.avif',
  'assets/items/paradoxShard.avif',
  'assets/items/phaseCrystal.avif',
  'assets/items/growthModule.avif',
  'assets/items/temporalEcho.avif',
  'assets/items/quantumCore.avif',
  'assets/items/memoryPrism.avif',
  'assets/items/voidDroplet.avif',
  'assets/items/bioMatrix.avif',
  'assets/items/organCore.avif',
  'assets/items/echoShard.avif',
  'assets/items/resonite.avif',
  'assets/items/energy.avif',
  'assets/items/health.avif',
  'assets/items/credit.avif',
  'assets/items/zenith.avif',
  'assets/items/fish1.avif',
  'assets/items/fish2.avif',
  'assets/items/fish3.avif',
  'assets/items/fish4.avif',
  'assets/items/fish5.avif',
  'assets/items/fish6.avif',
  'assets/items/fish7.avif',
  'assets/items/fish8.avif',
  'assets/items/ore1.avif',
  'assets/items/ore2.avif',
  'assets/items/ore3.avif',
  'assets/items/ore4.avif',
  'assets/items/ore5.avif',
  'assets/items/ore6.avif',
  'assets/items/ore7.avif',
  'assets/items/ore8.avif',
  'assets/items/ore9.avif',
  'assets/items/mod.avif',

  'assets/items/fishingSpear1.avif',
  'assets/items/fishingSpear2.avif',
  'assets/items/fishingBait1.avif',
  'assets/items/fishingBait2.avif',
  'assets/items/miningLaser1.avif',
  'assets/items/miningLaser2.avif',
  'assets/items/miningLens1.avif',
  'assets/items/miningLens2.avif',

  'img/backgrounds/inventory.avif',
  'img/backgrounds/weapons.avif',
  'img/backgrounds/chassis.avif',
  'img/backgrounds/market.avif',
  'img/backgrounds/forge.avif',
  'img/backgrounds/mods.avif',

  'img/chassis/bastion.avif',
  'img/chassis/bellum.avif',
  'img/chassis/plague.avif',
  'img/chassis/augur.avif',
  'img/chassis/sora.avif',

  'img/weapons/singularity.avif',
  'img/weapons/lightning.avif',
  'img/weapons/synthesis.avif',
  'img/weapons/resonance.avif',
  'img/weapons/supernova.avif',
  'img/weapons/cascade.avif',
  'img/weapons/mycelia.avif',
  'img/weapons/helios.avif',
  'img/weapons/krita.avif',
  'img/weapons/prism.avif',

  'img/factions/aegis_marksman_transparent.avif',
  'img/factions/aegis_grunt_transparent.avif',
  'img/factions/aegis_heavy_transparent.avif',
  'img/factions/aegis_recon_transparent.avif',
  'img/factions/aegis_boss_transparent.avif',

  'img/factions/kali_engineer_transparent.avif',
  'img/factions/kali_soldier_transparent.avif',
  'img/factions/kali_yp442_transparent.avif',
  'img/factions/kali_ix224_transparent.avif',
  'img/factions/kali_boss_transparent.avif',

  'img/avatars/avatar8.avif',
  'img/avatars/avatar7.avif',
  'img/avatars/avatar6.avif',
  'img/avatars/avatar5.avif',
  'img/avatars/avatar4.avif',
  'img/avatars/avatar3.avif',
  'img/avatars/avatar2.avif',
  'img/avatars/avatar1.avif',

  'img/planets/taloris.avif',
  'img/planets/eldoria.avif',
  'img/planets/glimmer.avif',
  'img/planets/complex.avif',
  'img/planets/aether.avif',
  'img/planets/avalon.avif',
  'img/planets/strava.avif',
  'img/planets/sylvan.avif',
  'img/planets/none.avif',

  'img/allies/voidmerchants.avif',
  'img/allies/chronohunters.avif',
  'img/allies/biomech.avif',

  'img/capsules/capsule1.avif',
  'img/capsules/capsule2.avif',
  'img/capsules/capsule3.avif',
  'img/capsules/capsule4.avif',
];

export default function ImagePreloader() {
  const [loaded, setLoaded] = useState(false);

  const { setIsLoadingImages } = useAppStore();

  useEffect(() => {
    const promises = images.map((src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve('loaded');
      });
    });

    Promise.all(promises).then(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (!loaded) return;
    setIsLoadingImages(false);
  }, [loaded]);

  return loaded ? <></> : <></>;
}